import React, {useEffect, useRef, useState} from 'react';
import {
   aslCloseHandler,
   isAndroid,
   isMacOS,
   isWeb,
   isWindows,
   isiOS,
} from '../../utils/utils';
const isDesktop = Platform.OS === 'macos' || Platform.OS === 'windows'; //The video player is same for windows and mac
import WebView from '../../components/webview';
import Video from '../../components/video';
import {
   Image,
   TouchableOpacity,
   View,
   StyleSheet,
   ActivityIndicator,
   Platform,
   AppState,
   Dimensions,
} from 'react-native';
import {useDispatch, useSelector} from 'react-redux';
import {selectAslPressClose} from '../../redux/slices/AslSlice';
import {isSafari, isChrome} from 'react-device-detect';
import {selectDownloadPreference} from '../../redux/slices/DownloadPreferenceSlice';

const VideoPlayer = props => {
   const dispatch = useDispatch();
   const userAgent = isWeb ? window.navigator.userAgent : null;
   const isPadChromeBrowser = userAgent?.includes('iPad') && isChrome;
   const iPhoneChromeBrowser = userAgent?.includes('iPhone OS') && isChrome;
   const videoViewWidth = props.isLandscapeMode ? 430 : 253;
   const videoViewHeight = props.isLandscapeMode ? 242 : 142;
   const [duration, setDuration] = useState(0);
   const [isPlaying, setIsPlaying] = useState(true);
   const [videoSource, setVideoSource] = useState({
      uri: '',
   });
   const PressClose = useSelector(selectAslPressClose);
   const webViewRef = React.useRef(null);
   const [videoSize, setVideoSize] = useState({
      width: videoViewWidth,
      height: videoViewHeight,
   });
   const {width, height} = Dimensions.get('window');

   const [appState, setAppState] = React.useState(AppState.currentState);
   const isDownloadPreferenceEnabled = useSelector(selectDownloadPreference);

   React.useEffect(() => {
      const handleAppStateChange = nextAppState => {
         setAppState(nextAppState);
      };

      // Add event listener for app state changes
      const myListener = AppState.addEventListener(
         'change',
         handleAppStateChange,
      );

      // Remove event listener on cleanup
      return () => {
         myListener.remove();
      };
   }, []);

   useEffect(() => {
      setVideoSource({
         uri: props.url,
      });
   }, [props]);
   useEffect(() => {
      if (PressClose) {
         handleEnded();
      }
      //When app is not in active mode
      if (appState !== 'active') {
         handleEnded();
         //aslCloseHandler(dispatch);
      }
   }, [PressClose, appState]);

   const [isLoading, setIsLoading] = useState(true);

   const onProgress = data => {
      const {playedSeconds} = data;
      const percent = Math.round((playedSeconds / duration) * 100);
      props.setProgress(percent);
   };
   const onProgressMobile = data => {
      const percent = Math.round((data.currentTime / duration) * 100);
      props.setProgress(percent);
   };
   const handleDuration = duration => {
      setDuration(duration);
   };
   const handleBuffer = ({isBuffering}) => {
      setIsLoading(isBuffering);
   };
   const handleStart = () => {
      props.onPlay();
   };
   const handleEnded = () => {
      props.onStop();
   };
   const onLoadForWeb = data => {
      setIsLoading(false);

      const {videoWidth, videoHeight} = data.getInternalPlayer();
      if (videoWidth && videoHeight) {
         // Calculate aspect ratio
         const aspectRatio = videoWidth / videoHeight;

         // Calculate height based on the desired aspect ratio
         const calculatedHeight = videoViewWidth / aspectRatio;

         // Update state with the new video size
         setVideoSize({width: videoSize.width, height: calculatedHeight});
      }
   };
   const onLoad = data => {
      setIsLoading(false);
      setDuration(data.duration);

      const {width: videoWidth, height: videoHeight} = data.naturalSize;

      if (videoWidth && videoHeight) {
         // Calculate aspect ratio
         const aspectRatio = videoWidth / videoHeight;

         // Calculate height based on the desired aspect ratio
         const calculatedHeight = videoViewWidth / aspectRatio;

         // Update state with the new video size
         setVideoSize({width: videoSize.width, height: calculatedHeight});
      }
   };

   const onLoadMacVideo = data => {
      const {duration, width, height} = data;
      if (width && height) {
         setIsLoading(false);
         // Calculate aspect ratio
         const aspectRatio = width / height;

         // Calculate height based on the desired aspect ratio
         const calculatedHeight = videoViewWidth / aspectRatio;

         // Update state with the new video size
         setVideoSize({width: videoSize.width, height: calculatedHeight});
      }
   };
   const onLoadWindowsVideo = data => {
      const {
         currentTime,
         duration,
         videoHeight: height,
         videoWidth: width,
      } = data;
      if (width && height) {
         setIsLoading(false);
         // Calculate aspect ratio
         const aspectRatio = width / height;

         // Calculate height based on the desired aspect ratio
         const calculatedHeight = videoViewWidth / aspectRatio;

         // Update state with the new video size
         setVideoSize({width: videoSize.width, height: calculatedHeight});
      }
   };
   const handleProgressForDesktop = ({nativeEvent}) => {
      const {loaded, total} = nativeEvent;
      const currentProgress = (loaded / total) * 100;
      props.setProgress(currentProgress);
   };
   const videoRef = React.useRef(null);

   const htmlSource = {
      html:
         isWindows || isiOS
            ? `
          <video id="norcatVideo"
          style="width: 100%; height: 100%; background-color:transparent;border-radius: 20px; object-fit: fill;"
            autoplay
            playsinline
            oncanplaythrough="window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'metadata', payload: { duration: this.duration, videoWidth: this.videoWidth, videoHeight: this.videoHeight } }));"
            ontimeupdate="window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'progress', payload: { currentTime: this.currentTime, duration: this.duration, videoWidth: this.videoWidth, videoHeight: this.videoHeight} }));"
            onended="window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'ended' }));"   
            onplaying="window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'onplaying' }));"   
            src="${videoSource.uri}"
          />
        `
            : `
        <video id="norcatVideo"
          style="width: 100%; height: 90%; background-color:transparent;border-radius: 25px; object-fit: fill;"
          autoplay
          ontimeupdate="window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'progress', payload: { currentTime: this.currentTime, duration: this.duration, videoWidth: this.videoWidth, videoHeight: this.videoHeight} }));"
          src="${videoSource.uri}"
        />
      `,
   };

   return !isDesktop && !isiOS ? (
      <View
         style={{
            position: 'absolute',
            margin: 16,
            marginEnd: 25,
            bottom: 0,
            right: 0,
            width: videoViewWidth,
            height: videoSize.height,
            borderTopLeftRadius: 15,
            borderTopRightRadius: 15,
            borderBottomLeftRadius: 15,
            borderBottomRightRadius: 15,
            backgroundColor:
               isLoading &&
               !isSafari &&
               !(isPadChromeBrowser || iPhoneChromeBrowser)
                  ? '#000000'
                  : 'transparent',
            overflow:
               isSafari || isPadChromeBrowser || iPhoneChromeBrowser
                  ? 'hidden'
                  : null,
         }}>
         {isWeb ? (
            <Video
               ref={videoRef}
               url={videoSource.uri}
               controls={false}
               playing={isPlaying}
               resizeMode={'cover'}
               width={videoViewWidth}
               height={videoSize.height}
               onReady={onLoadForWeb}
               onBuffer={handleBuffer}
               onProgress={onProgress}
               onDuration={handleDuration}
               onStart={handleStart}
               onEnded={handleEnded}
               config={{
                  attributes: {
                     //poster: 'https://i.stack.imgur.com/zw9Iz.png',
                     //poster: require('../../assets/my_logo_download.png'),
                  },
                  file: {
                     attributes: {
                        controlsList: 'nodownload',
                        playsInline: true,
                     },
                  },
               }}
               style={{
                  alignSelf: 'center',
                  backgroundColor: 'transparent',
                  objectFit: 'cover',
                  borderTopLeftRadius: 15,
                  borderTopRightRadius: 15,
                  borderBottomLeftRadius: 15,
                  borderBottomRightRadius: 15,
                  overflow: 'hidden',
               }}
            />
         ) : (
            <Video
               source={videoSource}
               ref={videoRef} // Store reference
               //   onBuffer={this.onBuffer} // Callback when remote video is buffering
               //   onError={this.videoError} // Callback when video cannot be loaded
               style={[
                  {
                     alignSelf: 'center',
                     width: '100%',
                     height: '100%',
                     backgroundColor: '#000',
                     borderRadius: 10,
                  },
                  !isAndroid && {
                     orientation: 'landscape',
                  },
               ]}
               onProgress={onProgressMobile}
               onDuration={handleDuration}
               onLoad={onLoad}
               onBuffer={handleBuffer}
               paused={!isPlaying}
               resizeMode="cover"
               fullscreen={false}
               onEnd={handleEnded}
               // onSeek={data => setCurrentTime(data.seekTime)}
            />
         )}

         {isLoading && (
            <View
               style={{
                  position: 'absolute',
                  justifyContent: 'center',
                  alignSelf: 'center',
                  alignItems: 'center',
                  width: '100%',
                  height: '100%',
               }}>
               <ActivityIndicator size="large" color="white" />
            </View>
         )}
         <TouchableOpacity
            onPress={() => {
               setIsPlaying(false);
               props.onStop();
            }}
            style={{
               width: props.isLandscapeMode ? 25 : 15,
               height: props.isLandscapeMode ? 25 : 15,
               justifyContent: 'center',
               position: 'absolute',
               alignSelf: 'flex-end',
               alignItems: 'center',
               right: 0,
               margin: props.isLandscapeMode ? 16 : 10,
               backgroundColor: '#fff',
               padding: 10,
               borderRadius: 20,
            }}>
            <Image
               source={require('../../assets/cross.png')}
               style={{
                  height: props.isLandscapeMode ? 10 : 8,
                  width: props.isLandscapeMode ? 10 : 8,
                  alignSelf: 'center',
                  tintColor: '#000',
               }}
            />
         </TouchableOpacity>
      </View>
   ) : (
      <View
         style={[
            styles.webViewContainer,
            {height: videoSize.height},
            {width: videoViewWidth},
            {marginEnd: isiOS && !props.isLandscapeMode ? 60 : 25},
         ]}>
         <WebView
            ref={webViewRef}
            style={[
               {
                  padding: 0,
                  margin: 0,
                  width: videoViewWidth,
                  height: videoSize.height,
                  backgroundColor: 'transparent',
               },
            ]}
            allowsInlineMediaPlayback
            javaScriptEnabled={true}
            onLoad={() => {
               if (isWindows || isiOS) {
                  // Add the event listener for receiving messages from the web content
                  webViewRef.current.injectJavaScript(`
                           window.addEventListener('message', function(event) {
                             document.external.notify(event.data);  
                           });
                         `);
               }
            }}
            onLoadStart={() => {
               setIsLoading(true);
            }}
            onLoadEnd={() => {
               setIsLoading(false);
            }}
            onProgress={handleProgressForDesktop}
            onMessage={event => {
               if (Platform.OS === 'windows' || isiOS) {
                  const {data} = event.nativeEvent;
                  const metadata = JSON.parse(data);
                  if (metadata.type === 'progress') {
                     const percent = Math.round(
                        (metadata.payload.currentTime /
                           metadata.payload.duration) *
                           100,
                     );
                     props.setProgress(percent);
                  }

                  if (metadata.type === 'metadata') {
                  }

                  if (metadata.type === 'ended') {
                     props.onStop();
                  }
                  if (metadata.type === 'onplaying') {
                     setIsLoading(false);
                  }
                  if (
                     metadata.payload &&
                     metadata.payload.duration !== 'undefined' &&
                     metadata.payload.videoWidth !== 'undefined' &&
                     metadata.payload.videoHeight !== 'undefined'
                  ) {
                     onLoadWindowsVideo(metadata.payload);
                  }
               } else {
                  // Event for mac os
                  // Event for mac os
                  const {data} = event.nativeEvent;
                  const metadata = JSON.parse(data);
                  if (metadata.type === 'progress') {
                     const percent = Math.round(
                        (metadata.payload.currentTime /
                           metadata.payload.duration) *
                           100,
                     );
                     props.setProgress(percent);
                  }

                  const message = JSON.parse(data);

                  if (message.event === 'VideoEnded') {
                     props.onStop();
                  }
                  /////
                  // Parse the message data
                  const jsonObj = JSON.parse(data);
                  if (
                     jsonObj.duration !== 'undefined' &&
                     jsonObj.width !== 'undefined' &&
                     jsonObj.height !== 'undefined'
                  ) {
                     onLoadMacVideo(JSON.parse(data));
                  }
               }
            }}
            injectedJavaScript={
               isMacOS
                  ? `
                        const video = document.getElementById('norcatVideo');
                        
                        function sendMessage() {
                          window.ReactNativeWebView.postMessage(video.currentTime.toString());
                        }
                        //For showing progress slider
                        video.addEventListener('timeupdate', sendMessage);
        
                        function sendVideoloadMessage() {
                          // Get video duration, width, and height
                          var duration = this.duration;
                          var width = this.videoWidth;
                          var height = this.videoHeight;
                          
                
                          //For setting the duration, height and widht of the video
                          window.ReactNativeWebView.postMessage(JSON.stringify({ duration, width, height }));
                        }
        
                        document.querySelector('video').addEventListener('loadedmetadata', sendVideoloadMessage);
        
                        document.querySelector('video').addEventListener('ended', function() {
                        // Post a message back to the WebView when the video ends
                        window.ReactNativeWebView.postMessage(JSON.stringify({event :'VideoEnded'}));
                        });

                        document.querySelector('video').addEventListener('loadeddata', function() {
                           // Post a message back to the WebView when the video ends
                           window.ReactNativeWebView.postMessage(JSON.stringify({event :'VideoLoaded'}));
                           });
                      `
                  : 'null'
            }
            source={
               isDownloadPreferenceEnabled === 'true' && isMacOS
                  ? {uri: videoSource.uri}
                  : htmlSource
            }
            allowsFileAccess={
               isDownloadPreferenceEnabled === 'true' && isMacOS ? true : false
            }
         />
         {isLoading && (
            <View
               style={{
                  position: 'absolute',
                  justifyContent: 'center',
                  alignSelf: 'center',
                  alignItems: 'center',
                  width: '100%', // Set width to 100% to ensure it covers the entire parent
                  height: '100%', // Set height to 100% to ensure it covers the entire parent
               }}>
               <ActivityIndicator size="large" color="white" />
            </View>
         )}

         <TouchableOpacity
            onPress={() => {
               setIsPlaying(false);
               props.onStop();
            }}
            style={{
               width: isiOS ? 25 : 28,
               height: isiOS ? 25 : 28,
               justifyContent: 'center',
               position: 'absolute',
               top: isiOS && props.isLandscapeMode ? 12 : 3,
               alignItems: 'center',
               right: isiOS && props.isLandscapeMode ? 12 : 3,
               margin: props.isLandscapeMode ? 16 : 10,
               backgroundColor: '#fff',
               padding: 10,
               borderRadius: 20,
               ...Platform.select({
                  windows: {
                     right: 10,
                  },
               }),
            }}>
            <Image
               source={require('../../assets/cross.png')}
               style={{
                  height: isiOS ? 10 : 14,
                  width: isiOS ? 10 : 14,
                  alignSelf: 'center',
                  tintColor: '#000',
               }}
            />
         </TouchableOpacity>
      </View>
   );
};

const styles = StyleSheet.create({
   container: {
      // borderRadius: 10,
      // marginEnd: 25,
      // bottom: 280,
      // right: 89,
      backgroundColor: 'red',
   },
   webViewContainer: {
      backgroundColor: 'transparent',
      borderRadius: 10,
      overflow: 'hidden',
      position: 'absolute',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'absolute',
      margin: 16,
      bottom: 0,
      right: 0,
   },
});

export default VideoPlayer;
